export default {
    loading: 'agentConnentData:loading',
    search: 'agentConnentData:search',
    statisticList: 'agentConnentData:list',
    phoneConnList: 'agentConnentData:phoneConnList',
    nolmalXdata: 'agentConnentData:nolmalXdata',
    tencentXYdata: 'agentConnentData:tencentXYdata',
    agents: 'agentConnentData:agents',
}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agentConnentData/constant.js